import logo from './logo.svg';
import './App.css';
import ContactForm from './components/ContactForm';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import React from 'react';
import AnimatedTopSection from './components/AnimatedTopSection';
import LandingPage from "./pages/landingpage";
import './index.css'


function App() {
  return (
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<LandingPage />} />

          {/* ավելացրու նաև գլխավոր էջը, եթե ունես */}
          {/* <Route path="/" element={<HomePage />} /> */}
        </Routes>
      </BrowserRouter>
  );
}

export default App;
